export default __webpack_public_path__ + "static/media/character_win_1.e142d6ea.mp3";